import React, { Component } from 'react'

export default class Details extends Component<any, any> {
    render() {
        const { name } = this.props
        return (
            <ul>
                <li style={{ listStyleType: 'circle' }}>{name}</li>
            </ul>
        )
    }
}
